import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { AuthModule, AuthService } from '@auth0/auth0-angular';
import { CommonModule } from '@angular/common';
import { DomianProviderService } from '../services/domain-provider.service';
import { Banner } from '../data/banner.data';

@Component({
  selector: 'app-login-redirect',
  standalone: true,
  imports: [CommonModule, AuthModule],
  providers: [AuthService],
  template: '<div></div>',

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginRedirectComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly bannerService = inject(DomianProviderService);

  ngOnInit(): void {
    this.login();
  }

  private buildLoginConfig() {
    const currentBanner =
      (this.bannerService.getBanner() as Banner) || Banner.SHOPRITE;
    return {
      appState: {
        target: '/' + window.location.search,
        banner: currentBanner,
      },
      authorizationParams: {
        redirect_uri: `${window.location.origin}/callback`,
        scope: 'openid profile email loyalty',
        response_type: 'code',
        debug: true,
      },
    };
  }

  login(): void {
    try {
      const loginConfig = this.buildLoginConfig();
      this.auth.loginWithRedirect(loginConfig);
    } catch (error) {
      console.error('Error during login:', error);
    }
  }
}
